import React, { FC } from 'react'
import { Button } from '@wmgtech/legato'

import { ProductsHeaderProps } from './ProductsHeader.props'
import { sortIconPosition } from 'shared/utils/sortIconPosition'

import './ProductsHeader.scss'

const ProductsHeader: FC<ProductsHeaderProps> = ({
  sortProducts,
  productSortField,
  children,
  isSpace = false
}) => (
  <div className="products-header">
    <div className="products-header__top">
      <div className="products-header__right">{children}</div>
    </div>
    <div className="products-header__sorting">
      <div className="products-header-col">
        <div className="products-header__col-item">Artist</div>
      </div>
      <div className="products-header-col">
        <div className="products-header__col-item">Products</div>
      </div>
      {isSpace ? (
        <div className="products-header-col">
          <div className="products-header__col-item">Zone</div>
        </div>
      ) : null}

      <div className="products-header-col">
        <Button
          className="products-header__btn"
          colorType="secondary-black"
          containerStyle="link"
          size="sm"
          icon={sortIconPosition(productSortField, 'type')}
          onClick={sortProducts('type')}
        >
          Type
        </Button>
      </div>
      <div className="products-header-col">
        <Button
          className="products-header__btn"
          colorType="secondary-black"
          containerStyle="link"
          size="sm"
          icon={sortIconPosition(productSortField, 'unit')}
          onClick={sortProducts('unit')}
        >
          Unit
        </Button>
      </div>
      <div className="products-header-col products-header-col--right">
        <Button
          className="products-header__btn"
          colorType="secondary-black"
          containerStyle="link"
          size="sm"
          icon={sortIconPosition(productSortField, 'releaseDate')}
          onClick={sortProducts('releaseDate')}
        >
          Release Date
        </Button>
      </div>
    </div>
  </div>
)

export default ProductsHeader
